// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 40px;
  position: relative;
  border: 1px solid var(--color-black);
  border-radius: 20px;
  text-align: center;
}
@media (max-width: 992px) {
  .wrapper {
    padding: 40px 15px;
  }
}
.wrapper .cross {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
}
.wrapper .title, .wrapper .sub-title {
  text-transform: uppercase;
  padding-bottom: 10px;
}
.wrapper .selection-time {
  padding: 30px;
  display: flex;
  justify-content: center;
}
.wrapper .selection-time .select-item {
  min-width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper .selection-time .select-item .circle {
  width: 20px;
  height: 20px;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background: transparent;
  transition: background 0.5s ease-in-out;
}
.wrapper .selection-time .select-item .circle.selected {
  background: #EBDFDA;
}
.wrapper .selection-time .select-item .circle ion-icon {
  visibility: hidden;
  opacity: 0;
  transition: opacity 200ms ease-in-out;
}
.wrapper .selection-time .select-item .circle ion-icon.visible {
  opacity: 1;
  visibility: visible;
}
.wrapper .selection-time .select-item p {
  font-family: AppFontMedium, sans-serif;
  color: var(--color-black);
  text-transform: uppercase;
}
.wrapper .pick-up-section {
  padding: 20px 0px;
}
.wrapper .pick-up-section .pick-up-asap {
  padding: 20px;
  border: 1px solid var(--color-black);
  border-radius: 50px;
  background: #EBDFDA;
}
.wrapper .pick-up-section .pick-up-asap p {
  font-size: 16px;
  text-transform: uppercase;
}
.wrapper .pick-up-section .pick-up-later {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.wrapper .pick-up-section .pick-up-later .pick-up-block {
  padding: 20px;
  border: 1px solid var(--color-black);
  border-radius: 50px;
  width: 46%;
}
.wrapper .pick-up-section .pick-up-later .pick-up-block.right {
  background: #EBDFDA;
}
.wrapper .pick-up-section .pick-up-later .day, .wrapper .pick-up-section .pick-up-later .time {
  position: relative;
}
.wrapper .pick-up-section .pick-up-later .day .show-item-date, .wrapper .pick-up-section .pick-up-later .time .show-item-date {
  position: absolute;
  bottom: 30px;
  background: white;
  border: 1px solid var(--color-black);
  border-radius: 10px;
  max-height: 250px;
  overflow: auto;
  padding: 10px;
  z-index: 999;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.wrapper .pick-up-section .pick-up-later .day .show-item-date.show-items, .wrapper .pick-up-section .pick-up-later .time .show-item-date.show-items {
  opacity: 1;
}
.wrapper .pick-up-section .pick-up-later .day .show-item-date .slot-square, .wrapper .pick-up-section .pick-up-later .time .show-item-date .slot-square {
  padding: 5px 10px;
}
.wrapper .pick-up-section .pick-up-later .day .show-item-date .slot-square.selected, .wrapper .pick-up-section .pick-up-later .time .show-item-date .slot-square.selected {
  background: #F6F1EF;
  border-radius: 16px;
  cursor: pointer;
}

.center-block {
  justify-content: center !important;
}

.background-time {
  background: #EBDFDA;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-time-slot-dialog/select-time-slot-dialog.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AADJ;ACCE;EDLF;IAOQ,kBAAA;EACN;AACF;AAAI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAER;AAAI;EACI,yBAAA;EACA,oBAAA;AAER;AAAI;EACI,aAAA;EACA,aAAA;EACA,uBAAA;AAER;AADQ;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAGZ;AAFY;EACI,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,uCAAA;AAIhB;AAHgB;EACI,mBAAA;AAKpB;AAHgB;EACI,kBAAA;EACA,UAAA;EACA,qCAAA;AAKpB;AAJoB;EACI,UAAA;EACA,mBAAA;AAMxB;AAFY;EACI,sCAAA;EACA,yBAAA;EACA,yBAAA;AAIhB;AAAI;EACI,iBAAA;AAER;AADQ;EACI,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;AAGZ;AAFY;EACI,eAAA;EACA,yBAAA;AAIhB;AADQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAGZ;AADY;EACI,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,UAAA;AAGhB;AAFgB;EACI,mBAAA;AAIpB;AADY;EACI,kBAAA;AAGhB;AAFgB;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;AAIpB;AAHoB;EACI,UAAA;AAKxB;AAHoB;EACI,iBAAA;AAKxB;AAJwB;EACG,mBAAA;EACA,mBAAA;EACA,eAAA;AAM3B;;AAEA;EACI,kCAAA;AACJ;;AACA;EACI,mBAAA;AAEJ","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n    padding: 40px;\n    position: relative;\n    border: 1px solid var(--color-black);\n    border-radius: 20px;\n    text-align: center;\n    @include mobile {\n        padding: 40px 15px;\n    }\n    .cross {\n        position: absolute;\n        top: 15px;\n        right: 15px;\n        width: 30px;\n        height: 30px;\n    }\n    .title, .sub-title {\n        text-transform: uppercase;\n        padding-bottom: 10px;\n    }\n    .selection-time {\n        padding: 30px;\n        display: flex;\n        justify-content: center;\n        .select-item {\n            min-width: 120px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            .circle {\n                width: 20px;\n                height: 20px;\n                border: 1px solid var(--color-black);\n                border-radius: 50%;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                margin-right: 10px;\n                background: transparent;\n                transition: background 0.5s ease-in-out;\n                &.selected {\n                    background: #EBDFDA;\n                }\n                ion-icon {\n                    visibility: hidden;\n                    opacity: 0;\n                    transition: opacity 200ms ease-in-out;\n                    &.visible {\n                        opacity: 1;\n                        visibility: visible;\n                    }\n                }\n            }\n            p {\n                font-family: AppFontMedium,sans-serif;\n                color: var(--color-black);\n                text-transform: uppercase;\n            }\n        }\n    }\n    .pick-up-section {\n        padding: 20px 0px;\n        .pick-up-asap {\n            padding: 20px;\n            border: 1px solid var(--color-black);\n            border-radius: 50px;\n            background: #EBDFDA;\n            p {\n                font-size: 16px;\n                text-transform: uppercase;\n            }\n        }\n        .pick-up-later {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n         \n            .pick-up-block {\n                padding: 20px;\n                border: 1px solid var(--color-black);\n                border-radius: 50px;\n                width: 46%;\n                &.right {\n                    background: #EBDFDA;\n                }\n            }\n            .day,.time {\n                position: relative;\n                .show-item-date {\n                    position: absolute;\n                    bottom: 30px;\n                    background: white;\n                    border: 1px solid var(--color-black);\n                    border-radius: 10px;\n                    max-height: 250px;\n                    overflow: auto;\n                    padding: 10px;\n                    z-index: 999;\n                    opacity: 0;\n                    transition: opacity 0.5s ease-in-out;\n                    &.show-items {\n                        opacity: 1;\n                    }\n                    .slot-square {\n                        padding: 5px 10px;\n                        &.selected {\n                           background: #F6F1EF;\n                           border-radius: 16px;\n                           cursor: pointer;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n.center-block {\n    justify-content: center !important;\n}\n.background-time {\n    background: #EBDFDA;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
